export interface House {
    houseName: string,
    roomAmount: number,
    floorAmount: number,
    el_install: boolean,
    rooms: any[],
    currentRoom: number
}

export const Extra: {[key:string]: any} = {
    varmepumpe: false,
    z41: false,
    weather: false,
    ISE: false,
    porttlf: false,
    logging: false,
    mobile: false,
    timer: false,
    rgbw: false,
    waterdetection: false,
    solidstate: false,
    constantlight: false,
    sonos: false,
    network: false,
    port24: false,
    accesspoints: {
        selected: false,
        amount_data: 0,
        amount_access: 0,
        data_val: [],
    },
    effect: false,
    access: false,
    outside: false,
    knx: false,
    macros: {
        selected: false,
        amount: 0,
        values: []
    },
    name: {
        varmepumpe: "Varmepumpe",
        z41: "Z41",
        weather: "Vaerstasjon",
        ISE: "ISE REMOTE",
        porttlf: "Porttelefon",
        logging: "Logging av temperatur inne og ute",
        mobile: "Mobil/PAD losning",
        timer: "Timer på stikkontakt",
        rgbw: "RGBW belysning",
        waterdetection: "Vanndeteksjon",
        solidstate: "Solidstate på varmekabel",
        constantlight: "Konstantlys styring",
        sonos: "Integrering med SONOS",
        network: "Nettverk",
        port24: "24 ports  svitsj",
        effect: "Effektstyring",
        outside: "Utelys",
        knx: "ThinKNX"
    }
}